import React from 'react';
import ReactDOM from 'react-dom/client';

import ProductState from './context/productsContext/ProductState';

import App from './App';
import reportWebVitals from './reportWebVitals';

// normalize.css
import './styles/normalize.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ProductState>
      <App />
    </ProductState>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
